import { Box, SectionHelper, Text } from '@wix/design-system';
import { SparklesFilledSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { dataHooks } from '../../../../../../utils/datahooks';
export const AiSectionHelper = _ref => {
  let {
    suggestion,
    texts,
    dataHook
  } = _ref;
  return /*#__PURE__*/React.createElement(SectionHelper, {
    dataHook: dataHook,
    showCloseButton: false,
    size: "small",
    skin: "standard",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "SP1",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Box, {
    color: "B10"
  }, /*#__PURE__*/React.createElement(SparklesFilledSmall, null)), /*#__PURE__*/React.createElement(Text, {
    dataHook: dataHook ? dataHooks.aiSectionHelperLabel(dataHook) : undefined,
    size: "tiny"
  }, texts.aiSuggestionLabel)), /*#__PURE__*/React.createElement(Text, {
    dataHook: dataHook ? dataHooks.aiSectionHelperSuggestion(dataHook) : undefined,
    size: "tiny",
    weight: "bold"
  }, texts.suggestion(suggestion))));
};
//# sourceMappingURL=ai-section-helper.js.map